<template lang="pug">
    .menu(v-if="content")
        MenuNav(:category="content.category")
        .menu__view
            transition(name="fade"  mode="out-in")
                MenuItem(:content="menuItems" :status="status" v-if="status")
            .menu__button-wr(v-if="!itemsEnd && menuItems.length > 0")
                button.menu__button(type="button" @click="loadNextItems()") Муу...
                MinPreloader
            .menu__top.menu__top--hide(@click="scrollTop()")
                SvgIcon(name="top" width="40" height="60")
</template>

<script>
    // @ is an alias to /src
    import '@/components/menu/menu.styl';
    import EventBus from '@/eventBus';
    import MenuNav from '@/components/common/menuNav/MenuNav.vue';
    import MenuItem from '@/components/common/menuItem/MenuItem.vue';
    import MinPreloader from '@/components/common/minPreloader/MinPreloader.vue';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'Menu',
        mixins: [AjaxHelpersVue],
        data() {
            return {
                content: null,
                menuItems: [],
                objImages: [],
                requestSend: false,
                itemsEnd: false,
                countItemsOfPage: 0,
                maxItemsForScrollBar: 4,
                status: '',
            }
        },
        components: {
            SvgIcon,
            MenuNav,
            MenuItem,
            MinPreloader
        },
        created() {
            EventBus.$on('loadMenuPage', params => {
                this.request(params.url, params)
                    .then(() => {
                        if (params.type) {
                            this.menuItems = [];
                            this.status = '';
                            this.loadItems(params.type);
                        }
                    });

            });

            EventBus.$on('loadMenuCategoryContent', params => {
              if (params.action === 'enter') {
                  let url = params.url.split('/');
                  this.request('/'+url[1], params)
                      .then(() => {
                          this.menuItems = [];
                          this.status = '';
                          this.loadItems(params.type);
                          EventBus.$emit('addMenuCategory');
                      });
              }
              else {
                  this.menuItems = [];
                  this.status = '';
                  this.loadItems(params.type);
                  EventBus.$emit('changeMenuCategory');
              }
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        methods: {
            request(url, params) {
              EventBus.$emit('menuPreloaderShow');
              return new Promise((resolve, reject) => {
                this.req('MenuPage:getMenuPage', {url}, res => {
                  this.content = res.content;
                  EventBus.$emit('setMenuTopActiveClass', params.url, params.from);
                  EventBus.$emit('pagePreloaderHide');
                  if(this.$router.currentRoute.fullPath === '/menyu') {
                      this.$router.push(this.content.category[0].link);
                  }
                  resolve();
                }, 'menu');
              })

            },

            loadItems(type, count) {
                $('.menu-item').addClass('menu-item--loading');
                $('.min-preloader__bell').addClass('min-preloader__bell--show');
                this.hideFooter();
                if(!count) {
                    count = 0;
                }

                let params = {
                    url: type,
                    count: count,
                    cartId: this.getCartId()
                }

                this.innerRequest('MenuPage:getMenuCategoryContent', params).then(response => {
                    if (this.checkProperty(response.content)) {
                        this.status = response.status;
                        if(this.status === '404') {
                            this.$router.push('/404');
                        } else {
                            this.menuItems = this.menuItems.concat(response.content);
                            this.itemsEnd = response.end;
                            for (let i = 0; i < this.menuItems.length; i++) {
                                this.objImages = this.objImages.concat({
                                    loaded: false,
                                    url: this.menuItems[i].imgPrev.path
                                });
                            }
                            this.$nextTick(() => {
                                this.countItemsOfPage = this.menuItems.length;
                                this.buttonTopAnimationEvents();
                                this.checkImgLoading(this.objImages);
                                $('.menu-item').removeClass('menu-item--loading');
                                $('.min-preloader__bell').removeClass('min-preloader__bell--show');
                                EventBus.$emit('menuPreloaderHide');
                            });
                        }
                    }
                });
            },

            loadNextItems() {
                if(!this.itemsEnd) {
                    let count = $('.menu-item__item').length;
                    $('.samedia').addClass('samedia--hide');
                    $('.footer').addClass('footer--hide');
                    this.loadItems(this.$router.currentRoute.params.type, count);
                }
            },

            buttonTopAnimationEvents() {
                var stop   = false;
                var $btnUp = $('.menu__top');

                $btnUp.on('mouseenter', function() {
                    $(this).addClass('menu__top--anima');

                    stop = false;
                });

                $btnUp.on('mouseleave', function() {
                    stop = true;
                });

                $btnUp.on('animationiteration', function() {
                    if(stop) {
                        $(this).removeClass('menu__top--anima');
                    }
                });
            },

            scrollTop() {
                $('html').animate({
                    scrollTop: 0
                }, 500);
            },

            hideFooter() {
                $('.samedia').addClass('samedia--hide');
                $('.footer').addClass('footer--hide');
                $('.page__decore--12').addClass('page__decore--hide-bottom');
                $('.page__decore--11').addClass('page__decore--hide-bottom');
                $('.page__decore--10').addClass('page__decore--hide-bottom');
            }
        }
    }
</script>
